// 思源黑体字体配置
// 这个文件通过导入的方式使用思源黑体字体

// 导入字体文件 - 这个文件包含了完整的思源黑体Base64数据
import './SourceHanSansCN-Regular-normal.js';

// 字体配置信息
export const sourceHanSansFontData = {
  fontName: 'SourceHanSansCN-Regular',
  fontStyle: 'normal',
  fontFileName: 'SourceHanSansCN-Regular-normal.ttf'
};

// 字体注册函数
export const registerSourceHanSansFont = (doc: any) => {
  try {
    // 字体已经通过导入的SourceHanSansCN-Regular-normal.js自动注册
    // 该文件会自动调用addFileToVFS和addFont方法
    
    // 验证字体是否可用
    const availableFonts = doc.getFontList();
    if (availableFonts[sourceHanSansFontData.fontName]) {
      console.log('思源黑体字体注册成功');
      return true;
    } else {
      console.warn('思源黑体字体未找到，可能注册失败');
      return false;
    }
  } catch (error) {
    console.error('思源黑体字体注册检查失败:', error);
    return false;
  }
};

// 检查字体是否可用
export const isSourceHanSansAvailable = (doc?: any): boolean => {
  if (doc) {
    try {
      const availableFonts = doc.getFontList();
      return !!availableFonts[sourceHanSansFontData.fontName];
    } catch (error) {
      console.error('检查字体可用性失败:', error);
      return false;
    }
  }
  // 如果没有传入doc参数，假设字体已导入
  return true;
};

// 使用说明和示例代码
export const fontUsageExample = `
// 使用示例：
import { setupPDFFont } from './sourceHanSansFont';
import jsPDF from 'jspdf';

const doc = new jsPDF();

// 设置字体（自动注册并应用思源黑体）
const fontAvailable = setupPDFFont(doc);

if (fontAvailable) {
  // 可以直接使用中文
  doc.text('你好，世界！紫微斗数', 20, 20);
  doc.text('命宫、财帛宫、官禄宫', 20, 40);
} else {
  // 回退到英文
  doc.text('Chinese font not available', 20, 20);
}
`;

// 快速设置函数（推荐使用）
export const setupPDFFont = (doc: any): boolean => {
  const fontRegistered = registerSourceHanSansFont(doc);
  
  if (fontRegistered) {
    // 设置为思源黑体
    doc.setFont(sourceHanSansFontData.fontName, sourceHanSansFontData.fontStyle);
    return true;
  } else {
    // 回退到默认字体
    console.warn('使用默认字体，中文可能显示为方块');
    doc.setFont('helvetica', 'normal');
    return false;
  }
};